<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Paquetes</a>
  </div>
  <h1 class="ui header"><img class="ui image" src="../../assets/parcels.png">
    <div class="content">Paquetes</div>
  </h1>
  <button v-if="role === 'courier'" class="ui basic button rightButton" v-on:click="getExpiredPackages()">
    <i class="cloud download icon"></i>Exportar caducados
  </button>
  <button v-if="role === 'master' || role === 'admin'" class="ui basic button rightButton" v-on:click="getAllPackages()">
    <i class="cloud download icon"></i>Exportar pedidos
  </button>
  <div class="ui stackable ">
    <div class="row">
      <h4 class="ui dividing header">Buscar un paquete</h4>
        <filterMaster :theRole="role" :theSearch="search" @filtersSelected="searchParcel"></filterMaster>
    </div>
    <div v-if="(searching && rows.length==0)" class="ui active centered inline loader"></div>
    <div v-if="(rows.length!=0)" class="row">
      <div class="column">
        <b>Total Pedidos: {{totalParcels}}</b>
        <!-- <h4 class="ui dividing header">Los últimos movimientos (Total Pedidos: {{ totalParcels }})</h4> -->
        <h4 class="ui dividing header">Los últimos movimientos</h4>
        <vue-good-table :columns="columns" :rows="rows" :lineNumbers="true" :pagination-options="{
                perPage: 50,
                enabled: true,
                mode: 'pages'
                }" :sort-options="{
                enabled: true,
                initialSortBy: {field: 'lastUpdate', type: 'desc'}
                }"
          @on-row-click="parcelInfo" styleClass="vgt-table striped condensed bordered">
          >
        </vue-good-table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import filterMaster from '@/components/filterMaster.vue'
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'parcelList_v2',
  data() {
    return {
      totalParcels: 0,
      parcels: null,
      role: null,
      searching: null,
      search: {
        // 'phone': null,
        // 'email': null,
        // 'codigo': null,
        // 'estado': null,
        // 'name': null,
        // 'cliente': null,
        // 'maquina': null,
        // 'fechaDesde': null,
        // 'fechaHasta': null,
      },
      columns: [{
          label: 'Cliente',
          field: 'from',
          filterOptions: {
            placeholder: 'Cliente',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          }
        },
        {
          label: 'APM',
          field: 'apm',
          filterOptions: {
            placeholder: 'APM',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Estado',
          field: 'status',
          filterOptions: {
            placeholder: 'Estado',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Nombre',
          field: 'name',
          filterOptions: {
            placeholder: 'Nombre',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Teléfono',
          field: 'phone',
          filterOptions: {
            placeholder: 'Teléfono',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Email',
          field: 'email',
          filterOptions: {
            placeholder: 'Email',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Barcode',
          field: 'barcode',
          filterOptions: {
            placeholder: 'Barcode',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Multiorder Code',
          field: 'multiorder_code',
          filterOptions: {
            placeholder: 'Multiorder Code',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Refcode',
          field: 'refcode',
          filterOptions: {
            placeholder: 'Refcode',
            enabled: true, // enable filter for this column
            trigger: 'keyup', //only trigger on enter not on keyup
          }
        },
        // {
        //   label: 'País',
        //   field: 'country',
        //   filterOptions: {
        //     placeholder: 'País',
        //     enabled: true, // enable filter for this column
        //     trigger: 'keyup', //only trigger on enter not on keyup
        //   }
        // },
        // {
        //   label: 'Servicio',
        //   field: 'service',
        //   filterOptions: {
        //     placeholder: 'Servicio',
        //     enabled: true, // enable filter for this column
        //     trigger: 'keyup', //only trigger on enter not on keyup
        //   }
        // },
        {
          label: 'Ult. Actualización',
          field: 'lastUpdate',
          width: '120px',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'yyyy-MM-dd HH:mm:ss',
        }
      ],
      rows: [],
    }
  },
  created() {
    this.searching = false
    this.role = JSON.parse(localStorage.admin).role;
/*     if (this.role !== 'master' && this.role !== 'clh') {
      let column = this.columns.find(obj => obj.field === 'courier');
      column.hidden = true;
      this.columns.map(obj => (obj.field === column.field) ? column : obj);
    } */
  },
  methods: {
    updateTable(req) {
      let parcels = []
      parcels = JSON.parse(JSON.stringify(req.data.data.parcels))
      this.totalParcels = parcels.length

      if (this.totalParcels == 0) {
        this.rows.push({
          'from': 'no encontrado',
        })
      } else {
        this.rows = parcels;
      }
    },
    goTo(where) {
      this.$router.push(where)
      this.searchParcel()
    },
    parcelInfo(params) {
      let routeData = this.$router.resolve('/parcels_v2/info/' + params.row.from + '/' + params.row.id);
      window.open(routeData.href, '_blank');
    },
    searchParcel(filtersSelected) {
      this.search = JSON.parse(JSON.stringify(filtersSelected));
      let aux = false;
      for(var usedfilters in this.search) {
        if(this.search.hasOwnProperty(usedfilters)) {
          aux = true;
        }
      }
      this.searching = true
      this.rows = []
        if (this.search.startDate > this.search.endDate){ //check marcado y fecha NO seleccionada
          this.$swal({
            type: 'info',
            text: 'La fecha inicio no puede ser superior a la fecha fin'
          })
          return this.rows.push({
            'from': 'no encontrado',
          })
        }

        if (this.search.endDate && !this.search.startDate){ //check marcado y fecha NO seleccionada
          this.$swal({
            type: 'info',
            text: 'Debe seleccionar una fecha de inicio'
          })
        } else {
          hapiickApi().post('/v4/shipments/search', {
            admin_id: JSON.parse(localStorage.admin).id,
            search: this.search
          })
          .then(request => {
            this.updateTable(request)
          })
          .catch((err) => {
            let type = '';
            let title = '';
            let text = '';
            let html = '';
            if (err.message === 'Network Error') {
              type = 'info'
              html= '<div style="font-size:20px!important"><p>Se ha producido un error inesperado.</p>'+
              '<b style="font-weight:bold!important;">Intenta acotar la busqueda</b></br>'+
              'Si el error persiste, por favor, pongase en contacto con hapiick.</div>';
            } else if (err.message === "Cannot read property 'parcels' of undefined" || err.message === "Request failed with status code 500") {
              type = 'error'
              title = 'Error interno!'
              text = 'Por favor, pongase en contacto con hapiick.'
            } else {
              type = 'error'
              title = 'Error'
              text = 'Error al obtener los paquetes.'
            }

            this.$swal({
              type: type,
              title: title,
              text: text,
              html: html
            })

            this.rows.push({
              'from': 'no encontrado',
            })
          })
        }
    },
    getAllPackages(){
      this.exportToCSVAllPakages(this.rows);
    },
    exportToCSVAllPakages(allPackages) {
      let packs = false;
      if (allPackages.length>0) {
        let filename = 'Packages.csv';
        if ( allPackages[0].from !== 'no encontrado') {
          var csv = [];
          csv.push('Cliente,Nombre,Telefono,Email,Barcode,RefCode,APM,Estado,Servicio,Ultima Act.');
          for (var i = 0; i < allPackages.length; i++) {
            let name = '';
            if (allPackages[i].name === null) {
              name = (allPackages[i].name);
            } else {
              name = (allPackages[i].name).replace(/,/g, '');
            }

            csv.push(
              (allPackages[i].from)+','+
              name+','+
              (allPackages[i].phone)+','+
              (allPackages[i].email)+','+
              (allPackages[i].barcode)+','+
              (allPackages[i].refcode)+','+
              (allPackages[i].apm)+','+
              (allPackages[i].status)+','+
              (allPackages[i].service)+','+
              allPackages[i].lastUpdate
            );
          }
          // download csv file
          this.downloadCSV(csv.join("\n"), filename)
          packs = true;
        }

      }/*  else {
        this.$swal({
          type: 'info',
          text: 'No hay paquetes'
        })
      } */

      if (!packs) {
        this.$swal({
          type: 'info',
          text: 'No hay paquetes'
        })
      }
    },
    getExpiredPackages(){
      hapiickApi().post('/v1/shipments/expired-packages', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then(request => {
        let packages = JSON.parse(JSON.stringify(request.data.data.expiredPackages));
        this.exportToCSV(packages);
      })
      .catch(() => console.log('error getting expired packages'))
    },
    exportToCSV(expiredPackages) {
      if(expiredPackages.length>0) {
        let filename = 'expiredPackages.csv'
        var csv = []
        csv.push('Taquilla,Barcode,Nombre,Email,Telefono,Fecha introduccion')
        for (var i = 0; i < expiredPackages.length; i++) {
          csv.push(
            (expiredPackages[i].apt_name)+','+
            (expiredPackages[i].barcode)+','+
            (expiredPackages[i].name).replace(/,/g, '')+','+
            (expiredPackages[i].email)+','+
            (expiredPackages[i].phone)+','+
            expiredPackages[i].in_apt_date
          )
        }
        // download csv file
        this.downloadCSV(csv.join("\n"), filename)
      } else {
        this.$swal({
          type: 'info',
          text: 'No hay paquetes caducados'
        })
      }

    },
    downloadCSV(csv, filename) {
      var csvFile;
      var downloadLink;
      if (window.Blob == undefined || window.URL == undefined || window.URL.createObjectURL == undefined) {
        alert("Your browser doesn't support Blobs");
        return;
      }

      csvFile = new Blob([csv], {
        type: "text/csv"
      });
      downloadLink = document.createElement("a");
      downloadLink.download = filename;
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
    }
  },
  components: {
    'filterMaster': filterMaster
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Parcels/parcelList_v2.vue